import { ReactNode } from 'react';

type PageHeaderProps = {
  title: string;
  label?: string;
  description?: string;
  actions?: ReactNode;
  help?: ReactNode;
};

export function PageHeader({ title, label, description, actions, help }: PageHeaderProps) {
  const heading = (
    <div className={`erp-page-header ${actions ? 'min-w-0' : ''}`.trim()}>
      {label ? <p className="erp-page-label">{label}</p> : null}
      <div className="flex items-center gap-2">
        <h1 className="erp-page-title">{title}</h1>
        {help}
      </div>
      {description ? <p className="erp-page-description">{description}</p> : null}
    </div>
  );

  if (actions) {
    return (
      <div className="erp-page-header-row">
        {heading}
        <div className="erp-btn-actions shrink-0">{actions}</div>
      </div>
    );
  }

  return heading;
}
